
export enum AdvancedAnalysisFieldType {

  Text = "text",
  Number = "number",
  Boolean = "boolean",
  Select = "select",
  SelectOrCreate = "select_or_create",
  MultiSelect = "multiselect",
  ArrayValues = "array_values",
  Array = "array",
  Object = "object",
  Json = "Json"

}